export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
};
